import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import ModalInputImage from './ModalInputImage';
import { Modal } from 'react-bootstrap';

class QuestionImages extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 1,
      id: this.props.question_id,
      name: '',
      images: [],
      image: '',
      modal: false,
    };

    this.adicionarImagem = this.adicionarImagem.bind(this);
    this.openModal = this.openModal.bind(this);
    this.refreshModalData = this.refreshModalData.bind(this);
    this.loadModalData = this.loadModalData.bind(this);
    this.changeStateByComponent = this.changeStateByComponent.bind(this);
  }


  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  changeStateByComponent (event, test) {
    var change = {};
    change['image'] = event;
    this.setState(change);
  } 
  
  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1) {
      this.setState({loaded: 2}, this.loadModalData());
    }
  }

  componentWillReceiveProps(newProps) {
    if(typeof newProps.question_id !== 'undefined') {
      this.setState({
        question_id: newProps.question_id,
      });
    }
  }


  openModal() {
    this.setState({modal: true});
  }

  loadModalData() {
    var header = this.refs.request_api.header();
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/questao/imagens/' + self.state.question_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({images: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });   
  }
  
  refreshModalData() {
    var header = this.refs.request_api.header();
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/questao/imagens/' + self.state.question_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({images: responseJson.data});
          self.setState({modal: true});
        }
      }).catch((error) => {
        console.error(error);
      });
    });   
  }

  adicionarImagem(event) {
    event.preventDefault();
    var data = new FormData();
    var imagedata = document.querySelector('input[type="file"]').files[0];
    data.append("name", this.state.name);
    data.append("image", imagedata);
    data.append("question_id", this.props.question_id);
    var header = this.refs.request_api.header();
    var self = this;
    this.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/questao/imagem', { method: 'POST', mode: 'cors', headers: value, body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
            var message = responseJson.message;
            fetch(config.get('api') + '/questao/imagens/' + self.state.question_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.setState({images: responseJson.data});
            }
            self.setState({modal: false});
            self.refreshModalData();
            self.props.handleAlert(message, responseJson.status, 'open');
          }).catch((error) => {
            console.error(error);
          });
        }
      }).catch((error) => {
        console.error(error);
      });
    });   
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <button type="button" className="btn btn-block btn-info btn" style={{marginTop: '25px'}} onClick={self.openModal}><i className="fa fa-fw fa-image"></i> Verificar imagens</button>
  <Modal show={self.state.modal} aria-labelledby="contained-modal-title-lg">
    <Modal.Header>
      <h4 className="pull-left">Imagens da questão</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>self.setState({ modal: false })}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={self.adicionarImagem}>
        <div className="form-group">
          <label>Nome:</label>
          <input type="text" name="name" className="form-control" placeholder="" value={self.state.name} onChange={self.handleChange.bind(self, 'name')} />
        </div>
        <div className="form-group">
          <ModalInputImage value={self.state.image} changeStateByComponent={self.changeStateByComponent} />
        </div>
        <div className="form-group">
        <button className="btn btn-primary btn-block" type="submit"><i className="fa fa-fw fa-save"></i> Adicionar imagem</button>
        </div>
      </form>
      <hr/>
      <div>
        {Object.keys(self.state.images).map(function(k) {
          
          return (
            <div className="text-center">
              <img src={config.get('cdn') + '/question_images/' + self.state.images[k].image} alt="" className="img-100" /><br/>
              <h4>{self.state.images[k].name}</h4>
              <h6><em id={'copiar-'+k}>{config.get('cdn') + '/question_images/' + self.state.images[k].image}</em></h6>
              {/*<button className="btn btn-sm btn-success" onClick={
                () => {
                  var copyText = document.getElementById('copiar-'+k);
                  copyText.select();               
                  document.execCommand("Copy");
                }
              }>Copiar</button>*/}
            </div>
          );
        })}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>self.setState({ modal: false })}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default QuestionImages;



// WEBPACK FOOTER //
// ./src/Components/Questions/Elements/QuestionImages.js